<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        App.ModalWarningDOE.TITLE
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="close()">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <div class="has-text-centered">
        <b-icon icon="close-circle" type="is-red" size="is-medium" />
        <p class="has-text-weight-semibold is-size-7">
          {{ App.ModalWarningDOE.DESCRIPTION }}
        </p>
      </div>
      <table
        class="table has-text-black"
        :title="General.TEXTS.FILE_LIST"
        :aria-describedby="General.TEXTS.FILE_LIST"
      >
        <thead>
          <tr>
            <th class="has-text-grey-dark is-size-7">{{ General.NUP }}</th>
            <th class="has-text-grey-dark is-size-7">
              {{ General.DOCUMENT }}
            </th>
            <th class="has-text-grey-dark is-size-7">
              {{ General.TYPE }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="document in listDocuments"
            :key="document.id"
            class="is-size-7"
          >
            <td class="has-text-weight-medium has-text-grey-dark">
              {{ applyMaskNUP(document.process_nup) }}
            </td>
            <td class="has-text-weight-semibold has-text-grey-dark">
              {{ document.attachment_name }}
            </td>
            <td>{{ document.document_type }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { App, General } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";

export default {
  name: "ModalWarningDOE",

  props: {
    listDocuments: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      App,
      General
    };
  },

  methods: {
    close() {
      this.$parent.close();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 650px;
  max-width: 75vw;
  min-height: 300px;
  max-height: 75vh;
  padding: 10px 5px;
  background-color: $background-light;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-evenly;
  overflow: auto;
}

.table {
  width: 100%;
}
</style>
